<template lang="html">
  <div class="">

    <div class="columns">
    <div class="column is-3 is-offset-2">
      <div class="field">
        <label class="label">user input phone</label>
        <div class="control">
          <input class="input" type="text" placeholder="+8801751255157" value="098789" v-model="phn">
        </div>
      </div>
      <div class="field">
        <label class="label">suggested phn</label>
        <div class="control">
          <input class="input " type="text" :placeholder="status.suggest_num" disabled>
        </div>
      </div>
      </div>
      <div class="colum is-4 is-offset-2">
        <h1>.</h1>
        <h1>.</h1>
        <table class="table is-bordered is-striped is-narrow is-fullwidth">
  <tbody>
    <tr v-if="status.core_valid !== undefined">
      <td>core_valid</td>
      <td>{{status.core_valid}}</td>
    </tr>
    <tr v-if="status.has_operator !== undefined">
      <td>has_operator</td>
      <td>{{status.has_operator}}</td>
    </tr>
    <tr v-if="status.operator_status !== undefined">
      <td>operator_status</td>
      <td>{{status.operator_status}}</td>
    </tr>
    <tr v-if="status.status !== undefined">
      <td>status</td>
      <td>{{status.status}}</td>
    </tr>
    <tr v-if="status.digit_status !== undefined">
      <td>digit_status</td>
      <td>{{status.digit_status}}</td>
    </tr>
    <tr v-if="status.need_digit !== undefined">
      <td>need_digit</td>
      <td>{{status.need_digit}}</td>
    </tr>
    <tr v-if="status.has_exceed !== undefined">
      <td>has_exceed</td>
      <td>{{status.has_exceed}}</td>
    </tr>
    <tr v-if="status.exceed !== undefined">
      <td>exceed</td>
      <td>{{status.exceed}}</td>
    </tr>
    <tr v-if="status.exceed_digit !== undefined">
      <td>exceed_digit</td>
      <td>{{status.exceed_digit}}</td>
    </tr>
    <tr v-if="status.suggest_num !== undefined">
      <td>suggest number</td>
      <td>{{status.suggest_num}}</td>
    </tr>




  </tbody>
</table>



</div>

    </div>
      <hr>
      {{ status }}

      <hr>
      <a class="button is-primary" href="https://github.com/code4mk/bd-phone-validator/blob/master/README.md" target="
      _blank">read doc</a>
       <a class="button is-link" href="https://code4mk.org" target="_blank">code4mk.org</a>

  </div>


</template>

<script>
import bdPhone from '@0devco/bd-phone-validator'
export default {
  data () {
    return {
      msg: 'Atom_Vue',
      phn: '',
      status: []
    }
  },
   mounted() {
    const self = this
    let mm = ''
    var ttt = ''
    window.addEventListener("keyup", function(e) {
      // use self instead of this in here
      let to= self.phn
      let rr = self.status = bdPhone(to)
      console.log(rr)
    });
  },
  methods: {
    countUp: function (event) {
      // this.r = bdPhone(this.phn)
      // console.log('kk')
      // console.log(this.r)
      this.msg = event
    }
  }
}
</script>

<style lang="css" scoped >


</style>



// WEBPACK FOOTER //
// src/components/Test.vue